import { render, staticRenderFns } from "./cognitive-goals-select.vue?vue&type=template&id=4094a9fd"
import script from "./cognitive-goals-select.vue?vue&type=script&lang=js"
export * from "./cognitive-goals-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports